import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    card: {
      setQuery: {
        title: translate({ id: 'locationEditorField.card.setQuery.title' }),
        subtitle: (queryMinLength: number) =>
          translate({
            id: 'locationEditorField.card.setQuery.subtitle',
            values: { queryMinLength },
          }),
      },
      noAssets: {
        title: translate({ id: 'locationEditorField.card.noAssets.title' }),
        subtitle: translate({ id: 'locationEditorField.card.noAssets.subtitle' }),
      },
      loading: {
        title: translate({ id: 'locationEditorField.card.loading.title' }),
      },
    },
    warning: {
      lowAccuracy: {
        title: (locationStatus: uui.domain.client.Location['status']) => {
          switch (locationStatus) {
            case 'POSTCODE_ISSUE':
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.title.postcodeIssue',
              })
            case 'POSTCODE_LEVEL_ACCURACY':
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.title.postcodeAccuracy',
              })
            case 'LOW_ACCURACY':
            default:
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.title.lowAccuracy',
              })
          }
        },
        description: (locationStatus: uui.domain.client.Location['status']) => {
          switch (locationStatus) {
            case 'POSTCODE_ISSUE':
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.description.postcodeIssue',
              })
            case 'POSTCODE_LEVEL_ACCURACY':
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.description.postcodeAccuracy',
              })
            case 'LOW_ACCURACY':
            default:
              return translate({
                id: 'locationEditorField.warning.lowAccuracy.description.lowAccuracy',
              })
          }
        },
        confirm: translate({ id: 'locationEditorField.warning.lowAccuracy.confirm' }),
      },
      outOfTerritory: {
        title: translate({ id: 'locationEditorField.warning.outOfTerritory.title' }),
        description: translate({ id: 'locationEditorField.warning.outOfTerritory.description' }),
        subText: translate({ id: 'locationEditorField.warning.outOfTerritory.subText' }),
      },
      invalidLatLng: {
        title: translate({ id: 'locationEditorField.warning.invalidLatLng.title' }),
        description: translate({ id: 'locationEditorField.warning.invalidLatLng.description' }),
        action: translate({ id: 'locationEditorField.warning.invalidLatLng.action' }),
      },
    },
    actions: {
      copyCoordinates: translate({ id: 'locationEditorField.actions.copyCoordinates' }),
      adjustAddress: translate({ id: 'locationEditorField.actions.adjustAddress' }),
    },
  }))

  return api
}
